import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/globals.css';
import { initUmami } from './utils/analytics';
import { TracewayProvider } from '@tracewayapp/react';

// Initialize Umami analytics
initUmami();

const tracewayUrl = import.meta.env.VITE_TRACEWAY_URL;
const tracewayToken = import.meta.env.VITE_TRACEWAY_TOKEN;
const tracewayConnectionString =
  tracewayUrl && tracewayToken ? `${tracewayToken}@${tracewayUrl.replace(/\/$/, '')}/api/report` : null;

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

ReactDOM.createRoot(document.getElementById('root')!).render(
  tracewayConnectionString ? (
    <TracewayProvider connectionString={tracewayConnectionString}>{app}</TracewayProvider>
  ) : (
    app
  )
);
